import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-banner-slides-products',
  templateUrl: './banner-slides-products.component.html',
  styleUrls: ['./banner-slides-products.component.scss'],
})
export class BannerSlidesProductsComponent implements OnInit {
  private _domainId = environment.domainId;
  private _section = undefined;
  public homePage = [];
  public typeId = '';
  public edit = undefined;

  constructor(private httpSv: HttpService, private uiSv: UiServices) {}

  ngOnInit() {
    this.getHome();
  }

  async getHome() {
    try {
      const res = await this.httpSv.itemIndex(
        'admin/homepage/all',
        this._domainId
      );
      const data: any[] = res.data;
      this.homePage = data.filter((x) =>
        x.type.toLowerCase().includes('products')
      );
    } catch (err) {
      console.error(err);
    }
  }

  setImage(ev) {
    if (this._section) {
      this._section.file = ev.parameters && ev.parameters[0];
    }
  }

  setHome(ev) {
    const id = ev.detail.value;
    this._section = this.homePage.find((x) => x.id === id);
    this.edit = [{ file: this._section.file }];
    this.typeId = this._section.id;
  }

  async save() {
    try {
      await this.uiSv.showLoading();
      const obj = { id: this._section.id, file: this._section.file };
      await this.httpSv.itemAction(obj, 'admin/homepage', 'update');
      await this.uiSv.loading.dismiss();
      await this.uiSv.showToast('Guardado exitosamente');
    } catch (err) {
      console.error(err);
    }
  }
}
